import { uniqBy } from 'lodash';

import { Icons, type LBIcon } from '@/assets/icons/icons';

import type { MeetingTriggerKind } from '@littlebird/sdk';

export const MEETING_TRIGGER_COPY: Record<
  MeetingTriggerKind,
  { title: string; description: string; groupLabel: string; icon: LBIcon }
> = {
  meeting_started: {
    title: 'Meeting starts',
    description: 'Runs when a meeting recording starts',
    groupLabel: 'Meeting start trigger',
    icon: Icons.recordAudio,
  },
  meeting_summarized: {
    title: 'Meeting summary is ready',
    description:
      "Runs when a meeting's summary is ready, with the summary and transcript",
    groupLabel: 'Meeting summary trigger',
    icon: Icons.summarize,
  },
};

export const parseMeetingFilterText = (
  text: string,
  separator?: string
): string[] =>
  (separator ? text.split(separator) : [text])
    .map((value) => value.trim())
    .filter(Boolean);

export const uniqueMeetingFilterValues = (values: string[]): string[] =>
  uniqBy(values, (value) => value.toLowerCase());
